import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import axios from 'axios';
import {
    TextField,
    MenuItem,
    CircularProgress,
    InputAdornment,
    Typography,
    FormControlLabel,
    Checkbox,
    Alert,
    AlertTitle,
} from '@mui/material';
import { useSnackbar } from 'notistack';
import { useNavigate } from 'react-router';
import { connect } from 'trim-redux';
import {defaultVariables} from "../../../config";
import Grid from "@mui/material/Grid2";
import SingleFileChooser from "../fileManager/Components/SingleFileChooser";
import LoadingButton from "../../components/elements/LoadingButton";
import AppAnimate from "../../components/AppAnimate";
import RayaField from "../../components/elements/fields/RayaField";
import SingleImageChooser from "../fileManager/Components/SingleImageChooser";

const BulkTicketsPage = ({ receiver, user }) => {
    const { t } = useTranslation();
    const navigate = useNavigate();
    const { enqueueSnackbar } = useSnackbar();

    const [fields, setFields] = useState({
        message: '',
        receiver_group: 'all_shops',
    });
    const [type, setType] = useState('system');
    const [submitLoading, setSubmitLoading] = useState(false);
    const [errors, setErrors] = useState({});
    const [ticketFile, setTicketFile] = useState(null);
    const handleChange = (e) => {
        setErrors({ ...errors, [e.target.name]: '' });
        setFields({ ...fields, [e.target.name]: e.target.value });
    };

    const handleValidation = (callback) => {
        let newErrors = {};
        let isValid = true;
        if (!fields.message) {
            isValid = false;
            newErrors.message = t('emptyField');
        }
        if (!isValid) {
            enqueueSnackbar(t('someFieldsHasError'), { variant: 'warning' });
            setSubmitLoading(false);
            setErrors(newErrors);
        }
        callback(isValid);
    };

    const handleRequest = () => {
        const data = new FormData();
        data.append('message', fields.message);
        data.append('file_id', ticketFile ? ticketFile.id : 0);
        data.append('receiver_group', fields.receiver_group);
        const token = localStorage.getItem('ACT');
        const config = {
            headers: {
                Accept: 'application/json',
                Authorization: `Bearer ${token}`,
            },
        };

        axios
            .post(`${defaultVariables.url}/tickets/send-bulk`, data, config)
            .then((response) => {
                enqueueSnackbar(t('ticket_sent'), { variant: 'success' });
                setFields({
                    message: '',
                    receiver_group: 'all_shops',
                });
                setType('system');
                setSubmitLoading(false);
                setErrors({});
                setTicketFile(null);
            })
            .catch((err) => {
                console.error(err.response);
                enqueueSnackbar(t('detailsSetFailed'), { variant: 'error' });
                setSubmitLoading(false);
            });
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        setSubmitLoading(true);
        handleValidation((valid) => {
            if (valid) handleRequest();
        });
    };

    return (
        <AppAnimate animation='transition.slideUpIn' delay={200} title={t('bulkTicketTitle')}>
            <Grid container spacing={2}>
                <Grid item size={12}>
                    <Alert severity="info">
                        <AlertTitle>{t('bulkTicketTitle')}</AlertTitle>
                        {t('bulkTicketDescription')}
                    </Alert>
                </Grid>
                <Grid item size={{xs:12,md:4}}>
                    <RayaField
                        fullWidth
                        variant="outlined"
                        name="receiver_group"
                        value={fields.receiver_group}
                        label={t('ticket_receiver')}
                        onChange={handleChange}
                        select
                    >
                        <MenuItem value="all_shops">{t('all_shops')}</MenuItem>
                        <MenuItem value="markets">{t('markets')}</MenuItem>
                        <MenuItem value="restaurants">{t('restaurants')}</MenuItem>
                        <MenuItem value="all_customers">{t('all_customers')}</MenuItem>
                        <MenuItem value="ordered_customers">{t('ordered_customers')}</MenuItem>
                        <MenuItem value="couriers">{t('couriers')}</MenuItem>
                    </RayaField>
                </Grid>
                <Grid item size={{xs:12}}>
                    <RayaField
                        variant="outlined"
                        value={fields.message}
                        fullWidth
                        label={t('message')}
                        name="message"
                        multiline
                        minRows={5}
                        onChange={handleChange}
                        error={!!errors.message}
                        helperText={errors.message}
                    />
                </Grid>
                <Grid item size={12}>
                    <Typography>{t('imageBulkHint')}</Typography>
                </Grid>
                <Grid item size={{xs:6,md:4,lg:2}}>
                    <SingleImageChooser
                        initial={ticketFile}
                        onChange={(file) => setTicketFile(file)}
                        align="center"
                    />
                </Grid>
                <Grid item size={12}>
                    <LoadingButton
                        variant="contained"
                        color="primary"
                        onClick={handleSubmit}
                        loading={submitLoading}
                    >
                        {t('addTicket')}
                    </LoadingButton>
                </Grid>
            </Grid>
        </AppAnimate>
    );
};

const mstp = (state) => ({
    user: state.user,
});
export default connect(mstp)(BulkTicketsPage);
